import clsx from "classnames";
import { Container } from "reactstrap";
import styles from "./styles.module.scss";

export const DefaultPageTemplate = ({ className, content }) => {
  return (
    <>
      <section className={clsx(className, styles.root, "py-5", "bg-light")}>
        <Container>
          {content && (
            <div className={styles.content} dangerouslySetInnerHTML={{ __html: content }} />
          )}
        </Container>
      </section>
    </>
  );
};

export default DefaultPageTemplate;
